// 003 (FR-027, FR-028; research R7; data-model §7): does the signed-in parent have any children?
// Only an empty list is "none" (unlinked children count). `has` is cached for the session's user;
// failures are "unknown" and never block Home (FR-028). A 403 already triggers 002's onForbidden in
// authFetch. Reset on every sign-out (registered as a personal-data cleaner). Takes the list call as
// an argument so the session provider can import it without the API client (no import cycle).
import type { Api } from "@/api/types";

export type StudentsPresence = "has" | "none" | "unknown";

let cachedFor: string | null = null;

export const studentsProbe = {
  async check(
    list: () => Promise<Api["StudentList"]>,
    userKey: string,
  ): Promise<StudentsPresence> {
    if (cachedFor === userKey) return "has";
    try {
      const { items } = await list();
      if (items.length > 0) {
        cachedFor = userKey;
        return "has";
      }
      return "none";
    } catch {
      return "unknown";
    }
  },
  reset(): void {
    cachedFor = null;
  },
};
